import * as constants from '../../../constants';

export const getActionPaymentLink = ({ userType, claroAdEnabled }) => {
  if (userType === constants.ANONYMOUS_USER && claroAdEnabled) {
    return `/${constants.GetRegion()}/checkout-redirect`;
  }
  if (userType === constants.ANONYMOUS_USER) {
    return `/${constants.GetRegion()}/landing`;
  }
  return `/${constants.GetRegion()}/payment`;
};
